const InvalidStateError = () => {
  throw new Error("Controller not initialized");
};
export {
  InvalidStateError as default
};
//# sourceMappingURL=invalid-state-error.js.map
